import React from 'react';
var SORT_TEXT = {
  ASC: "\u25B2",
  DESC: "\u25BC",
  NONE: ''
};
export default function SortableHeaderCell(_ref) {
  var column = _ref.column,
      onSort = _ref.onSort,
      sortColumn = _ref.sortColumn,
      sortDirection = _ref.sortDirection,
      children = _ref.children;
  sortDirection = sortColumn === column.key && sortDirection || 'NONE';

  function onClick() {
    if (!onSort) return;
    var sortDescendingFirst = column.sortDescendingFirst || false;
    var direction;

    switch (sortDirection) {
      case 'ASC':
        direction = sortDescendingFirst ? 'NONE' : 'DESC';
        break;

      case 'DESC':
        direction = sortDescendingFirst ? 'ASC' : 'NONE';
        break;

      default:
        direction = sortDescendingFirst ? 'DESC' : 'ASC';
        break;
    }

    onSort(column.key, direction);
  }

  return /*#__PURE__*/React.createElement("span", {
    className: "rdg-header-sort-cell",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "rdg-header-sort-name"
  }, children), /*#__PURE__*/React.createElement("span", null, SORT_TEXT[sortDirection]));
}